import { type UseQueryResult, useQuery } from 'react-query';
import {
  PerformanceRuleApprovalService,
  PerformanceRuleService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_PerformanceRuleListDto,
} from '../../services/wealthlane-award-services';
import { type TableParamsType } from '../../types/common';

const useGetPerformanceRuleApprovalList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_PerformanceRuleListDto | undefined,
  unknown
> => {
  const {
    createdFromDate: evaluationPeriodFrom,
    createdToDate: evaluationPeriodTo,
    approvalStatusId: approvalStatus,
    ruleStatusId: ruleStatus,
    earnedStatus: earnedStatus,
    filter,
    sorting,
    skipCount,
    maxResultCount,
  } = tableInfo;
  const performanceRulesApprovalList = useQuery(
    [
      'getPerformanceRulesApprovalList',
      evaluationPeriodFrom,
      evaluationPeriodTo,
      approvalStatus,
      ruleStatus,
      earnedStatus,
      filter,
      sorting,
      skipCount,
      maxResultCount,
    ],
    async () => {
      return await handleRequest(
        PerformanceRuleApprovalService.getApiAwardApiAppPerformanceRuleApprovalApprovalPerformanceRuleList(
          evaluationPeriodFrom,
          evaluationPeriodTo,
          approvalStatus,
          ruleStatus,
          earnedStatus,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return performanceRulesApprovalList;
};

export default useGetPerformanceRuleApprovalList;
